module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_4.529c59c1.pdf";